import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Download } from 'lucide-react';

export const SupportQrDialog = ({ open, onOpenChange, path = '/support', label = 'Support page' }) => {
  const boxRef = useRef(null);
  const url = `${window.location.origin}${path}`;

  const download = () => {
    const canvas = boxRef.current?.querySelector('canvas');
    if (!canvas) return;
    const a = document.createElement('a');
    a.href = canvas.toDataURL('image/png');
    a.download = `${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}-qr.png`;
    a.click();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[380px]">
        <DialogHeader>
          <DialogTitle className="font-serif text-[18px]">{label} QR code</DialogTitle>
        </DialogHeader>
        <div className="text-[12.5px] text-stone-600 -mt-1">
          Scan-ready for print and digital media — episode covers, flyers, show notes, event banners.
        </div>
        <div ref={boxRef} className="grid place-items-center p-6 bg-white rounded-md border border-stone-200" data-testid="support-qr-canvas">
          <QRCodeCanvas value={url} size={512} includeMargin style={{ width: 220, height: 220 }} />
        </div>
        <div className="text-[11.5px] text-stone-500 text-center break-all">{url}</div>
        <Button data-testid="download-qr-btn" onClick={download} className="bg-stone-900 text-white hover:bg-stone-800">
          <Download className="w-3.5 h-3.5 mr-1.5" /> Download PNG (print quality)
        </Button>
      </DialogContent>
    </Dialog>
  );
};
